import { Layout, Link, Text } from '../../../components/core';
import { IconAlertTriangle } from '../../../components/icons/IconAlertTriangle';
import { getStylesheet } from '../../../styles';

export const CrisisSupport = ({ crisisPhone }: { crisisPhone: string }): JSX.Element => {
  return (
    <Layout.VStack {...styles.container} space={4}>
      <Layout.Center>
        <IconAlertTriangle size={8} color="warning.500" />
      </Layout.Center>
      <Text.para center>
        For crisis support via phone, call the 24/7 Crisis Support Line at{' '}
        <Link.para
          aria-label={`For 24/7 crisis support call ${crisisPhone} (opens in phone app)`}
          to={`tel:${crisisPhone}`}
        >
          {crisisPhone}
        </Link.para>
      </Text.para>
    </Layout.VStack>
  );
};

const styles = getStylesheet({
  container: {
    padding: 4,
    backgroundColor: 'warning.50',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: 'warning.300',
    alignItems: 'center',
  },
});
